import React from "react";
import styled from "@emotion/styled";
import {
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import {
  dateTimeFormat,
  painLevelBackgroundColor,
  timeDateFormat,
} from "../../utils/helpers";
import { useSelector } from "react-redux";
import RectangleSkeletons from "../RectangleSkeletons";

const StyledBox = styled(Box)(() => ({
  width: "16px",
  height: "16px",
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "4px",
  fontSize: "14px",
}));

const StyledDivider = styled(Divider)(() => ({
  borderColor: "rgba(0, 0, 0, 0.06)",
  height: "45px",
}));

const PainChartStatsUI = () => {
  const getPainStats = useSelector((state) => state.getPainStats);
  const { painStats } = getPainStats;

  const isBelow1200 = useMediaQuery("(max-width:1200px)");

  const painStatsItems = [
    {
      title: "Most recent pain",
      value: painStats?.pain_chart_stats?.most_recent_pain_level || 0,
      date: painStats?.pain_chart_stats?.most_recent_pain_time,
    },
    {
      title: "Average pain",
      value: Math.round(painStats?.pain_chart_stats?.average_pain_level) || 0,
    },
    {
      title: "Highest pain",
      value: painStats?.pain_chart_stats?.max_pain_level || 0,
      date: painStats?.pain_chart_stats?.max_pain_time || 0,
    },
    {
      title: "Pain Range",
      range: [
        painStats?.pain_chart_stats?.pain_level_range_start,
        painStats?.pain_chart_stats?.pain_level_range_end,
      ],
    },
  ];

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      gap="8px"
      sx={{
        background: "linear-gradient(180deg, #FCFCFC 0%, #F3F9FF 100%)",
      }}
      padding="12px"
      borderRadius="8px"
      justifyContent="space-between"
    >
      <Grid container spacing={0.5} justifyContent="space-between">
        {painStatsItems?.map((item, index) => (
          <Grid item key={index} display="flex" md={6} lg={3}>
            {index !== 0 && !(isBelow1200 && index === 2) && (
              <StyledDivider
                orientation="vertical"
                variant="middle"
                sx={{ marginRight: "14px" }}
              />
            )}

            <Stack gap="8px">
              <Typography variant="body2" color="secondary">
                {item?.title}
              </Typography>

              <Box display="flex" alignItems="center" gap="4px">
                {item?.range ? (
                  <>
                    {item?.range[0] >= 0 ? (
                      <StyledBox
                        sx={{
                          background: painLevelBackgroundColor(item.range[0]),
                          p: "9px",
                        }}
                      >
                        {item.range[0]}
                      </StyledBox>
                    ) : (
                      <></>
                    )}
                    <Typography>-</Typography>
                    {item?.range[1] >= 0 ? (
                      <StyledBox
                        sx={{
                          background: painLevelBackgroundColor(item.range[1]),
                          p: "9px",
                        }}
                      >
                        {item.range[1]}
                      </StyledBox>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {item?.value ? (
                      <StyledBox
                        component="span"
                        sx={{
                          background: painLevelBackgroundColor(item?.value),
                          padding: "9px",
                        }}
                      >
                        {item?.value}
                      </StyledBox>
                    ) : (
                      "-"
                    )}
                    {item?.date ? (
                      <Typography variant="caption" color="#0D0D0D">
                        {timeDateFormat(item?.date)}
                      </Typography>
                    ) : (
                      <></>
                    )}
                  </>
                )}
              </Box>
            </Stack>
          </Grid>
        ))}
      </Grid>
      {/* <Stack gap="8px" padding="0 6px">
            <Typography variant="body2" color="secondary">
              Most recent pain
            </Typography>
            <Box display="flex" alignItems="center" gap="2px">
              <StyledBox
                component="span"
                sx={{
                  background: painLevelBackgroundColor(3),
                  padding: "9px",
                }}
              >
                3
              </StyledBox>
              <Typography variant="caption" color="#0D0D0D">
                13 may, 12:00 am{" "}
              </Typography>
            </Box>
          </Stack>
          <StyledDivider orientation="vertical" variant="middle" />
          <Stack gap="8px">
            <Typography variant="body2" color="secondary">
              Average pain
            </Typography>
            <Box display="flex" alignItems="center" gap="2px">
              <StyledBox
                component="span"
                sx={{
                  background: painLevelBackgroundColor(7),
                  padding: "9px",
                }}
              >
                7
              </StyledBox>
            </Box>
          </Stack>
          <StyledDivider orientation="vertical" variant="middle" />
          <Stack gap="8px">
            <Typography variant="body2" color="secondary">
              Highest pain
            </Typography>
            <Box display="flex" alignItems="center" gap="2px">
              <StyledBox
                component="span"
                sx={{
                  background: painLevelBackgroundColor(3),
                  padding: "9px",
                }}
              >
                3
              </StyledBox>
              <Typography variant="caption" color="#0D0D0D">
                13 may, 12:00 am{" "}
              </Typography>
            </Box>
          </Stack>
          <StyledDivider orientation="vertical" variant="middle" />
          <Stack gap="8px">
            <Typography variant="body2" color="secondary">
              Pain Range
            </Typography>
            <Box display="flex" alignItems="center" gap="4px">
              <StyledBox
                component="span"
                sx={{
                  background: painLevelBackgroundColor(3),
                  padding: "9px",
                }}
              >
                3
              </StyledBox>
              -
              <StyledBox
                component="span"
                sx={{
                  background: painLevelBackgroundColor(3),
                  padding: "9px",
                }}
              >
                3
              </StyledBox>
            </Box>
          </Stack> */}
    </Box>
  );
};

export default PainChartStatsUI;
